module.exports = __webpack_public_path__ + "static/dj-f57d3abee5fee10a0383ce19c4387ed7.jpg";